import React from "react";

function AllEarningCard({
  title,
  rupee,
  des,
  color,
  desIcon,
  desColor,
  link,
  handleClickOpen,
  requestRaised = false,
  requestRaisedMessage = "",
  message,
  disabled
  
}) {

  return (
    <div className=" bg-white border border-[#CBD5E1] p-5  m-auto rounded-lg  h-[160px] flex flex-col  justify-center ">
      <div className="mb-4">
        <h2 className="   text-lg text-[#6C757D]  font-medium  ">{title}</h2>
      </div>
      <div>
        <h2 className={` mb-2 text-2xl text-[${color}]`}>{rupee}</h2>
        {link || des ? (
          <a href={link}>
            <p className={`text-sm  flex items-center  text-[${desColor}]`}>
              {desIcon} {des}
            </p>
          </a>
        ) : disabled ? (<p style={{color:"#0DA06A"}}>
           {message}
        </p>) : requestRaised ? (<p style={{color:"#0DA06A"}}>
           {requestRaisedMessage}
          </p>) : (
          <button
            onClick={handleClickOpen}
            className="btn-primary text-xs  font-medium h-[34px] w-[100px] "
          >
            Withdraw
          </button>
        )}
      </div>
    </div>
  );
}

export default AllEarningCard;
